<twc-popup caption="{{options.headerText ?? '' | translate}}" type="primary" [closable]="false"
    [width]="options.width ?? 's'">

    <twc-popup-content class="twc-mb-3">
        <div *ngIf="options.contentHeaderText" class="twc-message-box" [class]="contentHeaderClass">
            {{options.contentHeaderText | translate}}
        </div>
        <div *ngIf="options.contentSecondaryText" class="twc-message-box">
            {{options.contentSecondaryText | translate}}</div>
        <div *ngIf="options.contentText" class="twc-ml-2 twc-mr-2 twc-mt-3 twc-mb-2"
            [innerHTML]="options.contentText | translate"></div>

        <div class="twc-checkbox twc-mt-2" *ngIf="options.additionalCheckboxLabel">
            <input class="twc-checkbox-input" type="checkbox" [(ngModel)]="isAdditionalCheckboxSelected"
                id="additional-checkbox-label">

            <label class="twc-checkbox-label" for="additional-checkbox-label">
                {{ options.additionalCheckboxLabel | translate}}
            </label>
        </div>
    </twc-popup-content>

    <twc-popup-footer class="message-dialog-footer">
        <ng-container *ngIf="options.buttonsList">
            <button *ngFor="let button of options.buttonsList" class="twc-button"
                [ngClass]="{'twc-button-primary': button.primary, 'twc-button-link': !button.primary}"
                (click)="buttonClick(button)">
                <span> {{button.text | translate}} </span>
            </button>
        </ng-container>
    </twc-popup-footer>
</twc-popup>